import React from 'react';
import { useNavigate, useLocation, useParams, NavigateFunction, Location, Params } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { AppDispatch } from 'redux/store';

export interface WithRouterProps {
    navigate: NavigateFunction;
    location: Location;
    params: Params;
    dispatch: AppDispatch;
}

export function withRouter(Component: React.ComponentType<WithRouterProps>) {
    function ComponentWithRouterProp(props: any) {
        const navigate = useNavigate();
        const location = useLocation();
        const params = useParams();
        const dispatch = useDispatch<AppDispatch>();

        return <Component {...props} dispatch={dispatch} navigate={navigate} location={location} params={params} />;
    }

    return ComponentWithRouterProp;
}
